var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardSpecialDeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_689_824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3001 7.00881L17.7001 2.82715L16.4101 4.48465L21.0101 8.66632L22.3001 7.00881ZM8.18014 4.48465L6.90014 2.82715L2.30014 6.99798L3.59014 8.65548L8.18014 4.48465ZM12.8001 9.47882H11.3001V15.9788L16.0501 19.0663L16.8001 17.7338L12.8001 15.1663V9.47882ZM12.3001 5.14548C7.33014 5.14548 3.30014 9.51132 3.30014 14.8955C3.30014 20.2796 7.32014 24.6455 12.3001 24.6455C17.2701 24.6455 21.3001 20.2796 21.3001 14.8955C21.3001 9.51132 17.2701 5.14548 12.3001 5.14548ZM12.3001 22.4788C8.43014 22.4788 5.30014 19.088 5.30014 14.8955C5.30014 10.703 8.43014 7.31215 12.3001 7.31215C16.1701 7.31215 19.3001 10.703 19.3001 14.8955C19.3001 19.088 16.1701 22.4788 12.3001 22.4788Z",
    fill: "#F4B652"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_689_824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "white",
    transform: "translate(0.30014 0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardSpecialDeal);
export default __webpack_public_path__ + "static/media/dashboard_special_deal.7c3e654d9b5729b372c88249182348bf.svg";
export { ForwardRef as ReactComponent };